export const apiUrlInternal = process.env.REACT_APP_INTERNAL_API_URL;
export const apiUrlRetrohunt = process.env.REACT_APP_RETROHUNT_DOWNLOAD_URL;
